import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { IFRSAttemptDTO } from "../../../api/Quiz/GetIFRSAttempts";

interface IFRSAttemptsTableProps {
  data?: IFRSAttemptDTO[];
  // Where the "view answers" action points; the attempt id is appended.
  detailBasePath: string;
}

const formatDate = (dateString?: string | null) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours() % 12 || 12;
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = date.getHours() >= 12 ? "PM" : "AM";

  return `${day}.${month}.${year} - ${hours}:${minutes} ${ampm}`;
};

const IFRSAttemptsTable = ({ data, detailBasePath }: IFRSAttemptsTableProps) => {
  return (
    <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
      <table className="table-auto w-full">
        <thead className="text-lg capitalize">
          <tr className="bg-[#F1F4F9] rounded-t-lg">
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="text-left text-sm">Student</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="text-left text-sm">Email</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="text-left text-sm">Started</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="text-left text-sm">Submitted</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="text-left text-sm">Marks</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
              <div className="text-left text-sm">Graded</div>
            </th>
            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap"></th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {data && data.length > 0 ? (
            data.map((attempt) => (
              <tr key={attempt.id}>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap font-semibold">
                  {attempt.student.firstName} {attempt.student.lastName}
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  {attempt.student.email}
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  {formatDate(attempt.createdAt)}
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  {attempt.submittedAt ? (
                    formatDate(attempt.submittedAt)
                  ) : (
                    <span className="text-gray-400">Not submitted</span>
                  )}
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  {attempt.isMarked ? (attempt.marks ?? 0) : "—"}
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <span
                    className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ${
                      attempt.isMarked
                        ? "bg-green-100 text-green-700"
                        : "bg-amber-100 text-amber-700"
                    }`}
                  >
                    {attempt.isMarked ? "Graded" : "Pending"}
                  </span>
                </td>
                <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                  <div className="flex justify-center">
                    <Link
                      to={`${detailBasePath}/${attempt.id}`}
                      title="View answers"
                      className="flex flex-shrink-0 rounded-xl justify-center items-center border p-3 hover:bg-gray-50"
                    >
                      <Eye size={18} />
                    </Link>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={7}
                className="px-2 first:pl-5 last:pr-5 py-8 text-center"
              >
                <div className="text-sm text-gray-500">No attempts found</div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default IFRSAttemptsTable;
